// import React from "react";
// import { Select, Checkbox } from "antd";
// import { ReactComponent as SelectIcon } from "../../../assets/svgs/select-icon.svg";

// const { Option } = Select;

// const CustomSelect = ({
//   options,
//   mode = "single",
//   placeholder = "Select",
//   width = "100%",
//   height = "30px",
//   value,
//   onChange,
//   loading = false,
//   disabled = false,
// }) => {
//   const handleChange = (selectedValues) => {
//     if (mode === "multiple") {
//       if (selectedValues.includes("all_section")) {
//         const allSectionValues = options
//           .filter((opt) => opt.value !== "all_section")
//           .map((opt) => opt.value);
//         onChange(allSectionValues);
//       } else {
//         onChange(selectedValues);
//       }
//     } else {
//       onChange(selectedValues);
//     }
//   };

//   return (
//     <Select
//       mode={mode === "multiple" ? "multiple" : undefined}
//       placeholder={placeholder}
//       suffixIcon={<SelectIcon />}
//       style={{ width, height }}
//       value={value}
//       onChange={handleChange}
//       optionLabelProp="label"
//       loading={loading}
//       disabled={disabled}
//     >
//       {options.map((option) => (
//         <Option key={option.value} value={option.value} label={option.label}>
//           {mode === "multiple" ? (
//             option.value !== "all_section" ? (
//               <Checkbox checked={value?.includes(option.value)}>
//                 {option.label}
//               </Checkbox>
//             ) : (
//               <div>{option.label}</div>
//             )
//           ) : (
//             option.label
//           )}
//         </Option>
//       ))}
//     </Select>
//   );
// };

// export default CustomSelect;
import React from "react";
import { Select, Checkbox } from "antd";
import { ReactComponent as SelectIcon } from "../../../assets/svgs/select-icon.svg";

const { Option } = Select;

const CustomSelect = ({
  options,
  mode = "single",
  placeholder = "Select",
  width = "100%",
  height = "30px",
  value,
  onChange,
  loading = false,
  disabled = false,
  getPopupContainer,
  className,
  open,
  onDropdownVisibleChange,
}) => {
  const handleChange = (selectedValues) => {
    if (mode === "multiple") {
      // Handle "Select All Section" logic
      if (selectedValues.includes("all_section")) {
        const allSectionValues = options
          .filter((opt) => opt.value !== "all_section")
          .map((opt) => opt.value);
        onChange(allSectionValues);
      }
      // Handle "Select All Role" logic
      else if (selectedValues.includes("all_role")) {
        const allRoleValues = options
          .filter((opt) => opt.value !== "all_role")
          .map((opt) => opt.value);
        onChange(allRoleValues);
      } else {
        onChange(selectedValues);
      }
    } else {
      onChange(selectedValues);
    }
  };

  return (
    <Select
      mode={mode === "multiple" ? "multiple" : undefined}
      placeholder={placeholder}
      suffixIcon={<SelectIcon />}
      style={{ width, height }}
      value={value}
      onChange={handleChange}
      optionLabelProp="label"
      loading={loading}
      disabled={disabled}
      getPopupContainer={getPopupContainer}
      className={className}
      open={open}
      onDropdownVisibleChange={onDropdownVisibleChange}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value} label={option.label}>
          {mode === "multiple" ? (
            // Don't show checkbox for "Select All" options
            option.value !== "all_section" && option.value !== "all_role" ? (
              <Checkbox checked={value?.includes(option.value)}>
                {option.label}
              </Checkbox>
            ) : (
              <div>{option.label}</div>
            )
          ) : (
            option.label
          )}
        </Option>
      ))}
    </Select>
  );
};

export default CustomSelect;
